import React from "react";
import { useLtiAuth } from "../hooks/useLtiAuth";

interface LtiAuthWrapperProps {
  children: React.ReactNode;
}

const LtiAuthWrapper: React.FC<LtiAuthWrapperProps> = ({ children }) => {
  const { isAuthenticating, error } = useLtiAuth();

  // Show loading state while authenticating
  if (isAuthenticating) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Authenticating with LTI...</p>
        </div>
      </div>
    );
  }

  // Show error state if authentication failed
  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center max-w-md mx-auto p-6">
          <div className="text-red-500 text-6xl mb-4">⚠️</div>
          <h1 className="text-2xl font-bold text-gray-900 mb-2">
            Authentication Error
          </h1>
          <p className="text-gray-600 mb-4">{error}</p>
          <button
            onClick={() => window.close()}
            className="bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700"
          >
            Close Window
          </button>
        </div>
      </div>
    );
  }

  // Render children normally
  return <>{children}</>;
};

export default LtiAuthWrapper;

